import { Col, Container, Row, Tab, Tabs } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { ResponsiveBreadcrumb } from "../../components/Layout/ResponsiveBreadcrumb";
import { UserInvitationsPage } from "../UserInvitationsPage/UserInvitationsPage";
import { UsersListPage } from "../UsersListPage/UsersListPage";

const UsersPage = () => {
    return (
        <Container fluid>
            <Helmet>
                <title>Users</title>
            </Helmet>

            <ResponsiveBreadcrumb
                items={[
                    { text: "Settings", to: "/settings" },
                    { text: "Users" },
                ]}
            />
            <Row>
                <Col>
                    <h1>Users</h1>
                    <Tabs defaultActiveKey="required" className="mb-3" mountOnEnter>
                        <Tab eventKey="required" title="Active Users">
                            <UsersListPage />
                        </Tab>
                        <Tab eventKey="due" title="Invitations">
                            <UserInvitationsPage />
                        </Tab>
                    </Tabs>
                </Col>
            </Row>
        </Container>
    );
};

export { UsersPage };
